module.exports = __webpack_public_path__ + "img/本年收益 (1).ef52ae89.png";